import { useQuery } from "react-query";
import EarningsPerPeriodPresenter from "./EarningsPerPeriodPresenter";

import { TotalYear } from "./earnings-per-period.models";
import useEventListeners from "@arelia-hooks/useEventListeners";
import { DONATION_UPDATE_EVENT_NAME, MERCH_UPDATE_EVENT_NAME, PERFORMANCE_DETAILS_UPDATE_EVENT_NAME } from "../../features/earnings/constants";
import { ComponentProps } from "@arelia-types/widget";
import { http } from "src/api/http";

export default function EarningsPerYearContainer({ config }: ComponentProps) {
  const { data = {
    thisYear: 0,
    lastYear: 0,
  }, isLoading, isError, refetch } = useQuery<TotalYear>({
    queryKey: ["total-year"],
    queryFn: () => http(`/api/earnings/total-year${config.query ? `?${config.query}` : ''}`)
  });

  useEventListeners([
    DONATION_UPDATE_EVENT_NAME,
    MERCH_UPDATE_EVENT_NAME,
    PERFORMANCE_DETAILS_UPDATE_EVENT_NAME
  ], () => {
    refetch();
  });

  return (
    <EarningsPerPeriodPresenter
      earnings={data}
      loading={isLoading}
      error={isError}
      timespan="Year"
      widgetId="THIS_YEAR_EARNINGS"
    />
  );
}
